import { t as r, c as o, s as n } from "./format._HymmFPq.js";
function i(a, t) {
  const e = r(a);
  return isNaN(t) ? o(a, NaN) : (t && e.setDate(e.getDate() + t), e);
}
function f(a, t) {
  const e = n(a), s = n(t);
  return +e == +s;
}
function u(a, t) {
  const e = r(a), s = r(t);
  return e.getTime() > s.getTime();
}
function D(a, t) {
  return i(a, -t);
}
export {
  i as a,
  u as b,
  f as i,
  D as s
};
//# sourceMappingURL=subDays.KNyakmpi.js.map
